import { FileType } from '@office-start/document-types';
// Helper function that returns title header by analysing the current route
export function getDefaultHeaderText(context, locStrings) {
    var route = context.router.getCurrentRoute();
    var loc = locStrings.authPageResources;
    switch (route === null || route === void 0 ? void 0 : route.app) {
        case FileType.Word:
            return loc.wordPageTitle;
        case FileType.Excel:
            return loc.excelPageTitle;
        case FileType.PowerPoint:
            return loc.powerPointPageTitle;
        case FileType.Sway:
            return loc.swayPageTitle;
        case FileType.OneNote:
            return loc.oneNotePageTitle;
        case FileType.Forms:
            return loc.formsPageTitle;
        case FileType.Visio:
            return loc.visioPageTitle;
        case FileType.Stream:
            return loc.streamPageTitle;
        default:
            return loc.m365_authPageHeader;
    }
}
//# sourceMappingURL=getDefaultHeaderText.js.map